import { FC } from "react"
import { ISupply } from "../../../app/reducers/ordersReducer"
import { FormSamsonOrder } from "../FormSamsonOrder"
import { getWBOrdersForSamson } from "./utils"

type FormWBSamsonOrderProps = {
  selectedSupplies: ISupply[]
}

export const FormWBSamsonOrder: FC<FormWBSamsonOrderProps> = ({
  selectedSupplies,
}) => {
  return (
    <FormSamsonOrder
      isDisabled={
        !selectedSupplies?.length ||
        !selectedSupplies?.some((supply) => !!supply.orders?.length)
      }
      getOrdersForSamson={() => getWBOrdersForSamson(selectedSupplies || [])}
      supplies={selectedSupplies || []}
    />
  )
}
